import { useInfiniteQuery } from 'react-query';
import type { UseInfiniteQueryOptions } from 'react-query';
import {
  getFanLettersList,
  type GetFanLettersListResponse,
  type GetFanLettersQuery
} from '../../services/bettieFanLettersService';

const DEFAULT_PER_PAGE = 10;

export function useGetFanLettersInfinite(
  query: GetFanLettersQuery,
  options?: UseInfiniteQueryOptions<GetFanLettersListResponse, Error>
) {
  const normalizedQuery = query ?? {};
  const perPage = normalizedQuery.per_page ?? DEFAULT_PER_PAGE;

  return useInfiniteQuery<GetFanLettersListResponse, Error>(
    [
      'fanLettersInfinite',
      normalizedQuery.chat_room_id,
      normalizedQuery.only_unseen,
      normalizedQuery.member_id,
      normalizedQuery.member_persona_id,
      perPage
    ],
    ({ pageParam = 1 }) =>
      getFanLettersList({
        query: {
          ...normalizedQuery,
          page: pageParam,
          per_page: perPage
        }
      }),
    {
      getNextPageParam: (lastPage) => {
        const currentPage = lastPage?.meta?.pagination?.currentPage;
        const totalPages = lastPage?.meta?.pagination?.totalPages;

        if (typeof currentPage === 'number' && typeof totalPages === 'number') {
          if (currentPage < totalPages) return currentPage + 1;
          return undefined;
        }

        return undefined;
      },
      staleTime: 60 * 1000,
      cacheTime: 5 * 60 * 1000,
      ...options
    }
  );
}
